import GuidUtils from '@/shared/utils/guid'

export default class TableMeasurement {
  constructor({
    id,
    height,
    weight,
    measurementDate
  } = {}) {
    this.id = id || GuidUtils.emptyGuid,
    this.height = height,
    this.weight = weight,
    this.measurementDate = measurementDate
  }
}